exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contactButton__contactButtonWrapper___2C45w {\n  position: fixed;\n  bottom: 15px;\n  right: 10px;\n  z-index: 2; }\n  .contactButton__contactButtonWrapper___2C45w .contactButton__contactButton___t1-Vd {\n    border-radius: 8px;\n    font-weight: 600;\n    height: 42px;\n    font-size: 13px;\n    transition: 300ms;\n    transform-origin: center bottom; }\n    .contactButton__contactButtonWrapper___2C45w .contactButton__contactButton___t1-Vd:hover {\n      transform: scale(1.05); }\n\n.contactButton__label___4PuvY {\n  display: block;\n  margin-bottom: 8px; }\n  .contactButton__label___4PuvY::after {\n    content: \"*\";\n    margin-left: 5px;\n    color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"contactButtonWrapper": "contactButton__contactButtonWrapper___2C45w",
	"contactButton": "contactButton__contactButton___t1-Vd",
	"label": "contactButton__label___4PuvY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/ContactButton/contactButton.scss
// module id = 4033
// module chunks = 6